<template>
    <div>
        <p>Danger zone!</p>

        <div class="notification is-warning">
            Once you delete space, you can't recover it anymore!
        </div>

        <base-button
            v-if="space_permission('SPACE_DELETE')"
            :loading="remove.loading"
            @click="show_confirm = true"
            class="is-danger"
            icon="fas fa-trash-alt"
            text="Delete it anyway"/>

        <div v-else class="notification is-danger">You have not delete access.</div>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this Space?"
            @close="show_confirm = false"
            @ok="remove_space"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'SpaceSettingsDelete',
    props: ['space'],
    data() {
        return { show_confirm: false };
    },
    computed: mapState('spaces', ['remove']),
    methods: {
        remove_space() {
            this.$store.dispatch('spaces/remove', {
                space_id: this.space.id,
            }).then(() => {
                this.$router.push({ name: 'spaces' });
            });
        },
    },
};
</script>
